import { apiClient } from '@/shared/lib/axios';
import { BankAccountType } from '@/types/admin-clinic-info';
import { useQuery } from '@tanstack/react-query';

type Response<T> = {
  data: T[];
};

export const getBankAccountType = async (
  siteType: string | null
): Promise<Response<BankAccountType>> => {
  const response = await apiClient.get<Response<BankAccountType>>(
    `/admin/${siteType}/master-data/bank-account-types`
  );
  return response.data;
};

export const useAdminBankAccountType = (siteType: string | null) => {
  return useQuery({
    queryKey: ['bank-account-types', siteType],
    queryFn: () => getBankAccountType(siteType),
  });
};
